type AdminStats = {
  totalRevenue: number;
  monthlyRevenue: number;
  totalOrders: number;
  pendingOrders: number;
  approvedProducts: number;
  pendingProducts: number;
  approvedEvents: number;
  pendingEvents: number;
  totalVendors: number;
  totalOrganizers: number;
  totalUsers?: number;
};

export type AdminOverviewCardKey =
  | 'totalRevenue'
  | 'totalOrders'
  | 'approvedProducts'
  | 'approvedEvents'
  | 'totalVendors'
  | 'totalOrganizers';

const formatNumber = (n: number) => n.toLocaleString('fr-FR');
const formatPrice = (n: number) => `${n.toLocaleString('fr-FR')} FCFA`;

export default function AdminStatsOverview({
  stats,
  onCardClick,
}: {
  stats: AdminStats;
  onCardClick?: (key: AdminOverviewCardKey) => void;
}) {
  const cards = [
    { key: 'totalRevenue' as const, label: 'Revenus totaux', value: formatPrice(stats.totalRevenue), icon: 'ri-money-cny-circle-line', color: 'from-gold to-gold-dark', sub: `+${formatPrice(stats.monthlyRevenue)} ce mois`, subIcon: 'ri-arrow-up-line', subColor: 'text-emerald-600' },
    { key: 'totalOrders' as const, label: 'Commandes', value: formatNumber(stats.totalOrders), icon: 'ri-shopping-bag-line', color: 'from-navy to-navy-lighter', sub: `${stats.pendingOrders} en attente`, subIcon: 'ri-time-line', subColor: 'text-gold-dark' },
    { key: 'approvedProducts' as const, label: 'Produits actifs', value: formatNumber(stats.approvedProducts), icon: 'ri-store-line', color: 'from-navy-light to-navy-lighter', sub: `${stats.pendingProducts} à valider`, subIcon: 'ri-time-line', subColor: 'text-gold-dark' },
    { key: 'approvedEvents' as const, label: 'Événements actifs', value: formatNumber(stats.approvedEvents), icon: 'ri-calendar-event-line', color: 'from-gold-dark to-gold', sub: `${stats.pendingEvents} à valider`, subIcon: 'ri-time-line', subColor: 'text-gold-dark' },
    { key: 'totalVendors' as const, label: 'Vendeurs', value: formatNumber(stats.totalVendors), icon: 'ri-user-star-line', color: 'from-navy to-navy-light', sub: 'Comptes vendeurs', subIcon: 'ri-check-line', subColor: 'text-emerald-600' },
    { key: 'totalOrganizers' as const, label: 'Organisateurs', value: formatNumber(stats.totalOrganizers), icon: 'ri-group-line', color: 'from-gold to-gold-light', sub: 'Comptes organisateurs', subIcon: 'ri-check-line', subColor: 'text-emerald-600' },
  ];

  return (
    <div className="grid grid-cols-2 lg:grid-cols-3 xl:grid-cols-6 gap-4">
      {cards.map((card, i) => (
        <button
          key={i}
          type="button"
          onClick={() => onCardClick?.(card.key)}
          className="bg-white rounded-xl p-4 border border-cream-dark hover:border-gold/30 transition-all text-left cursor-pointer"
        >
          <div className={`w-10 h-10 flex items-center justify-center rounded-xl bg-gradient-to-br ${card.color} mb-3`}>
            <i className={`${card.icon} text-white text-lg`}></i>
          </div>
          <p className="text-xs text-gray-500 mb-1">{card.label}</p>
          <p className="text-lg font-bold text-navy leading-tight">{card.value}</p>
          <div className={`flex items-center gap-1 mt-1 ${card.subColor}`}>
            <i className={`${card.subIcon} text-xs`}></i>
            <span className="text-xs">{card.sub}</span>
          </div>
        </button>
      ))}
    </div>
  );
}
